export const PROJECT_NAME = 'object_groups'
